import React from "react";
import { Box, Link } from "@mui/material";
import { ListingCellCenter, ListingCellLeft, ListingCellRight, ListingIconMetric, ListingMetricValue } from "../../../components/commonComponents/TabularLists/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  HtmlTooltip,
  HtmlTooltipDisabled,
  IconText,
} from "../../../components/commonComponents/StyledComponents/styled";
import ProgressBar from "../../../components/commonComponents/Progress/ProgressBar";
import { Store, Edit, Visibility, PhotoSizeSelectActualOutlined, ContentCopyTwoTone, Euro, AllInclusive } from "@mui/icons-material";
import Confirmation from "../../../components/commonComponents/Confirmation";
import { fetchIndependentOwnerList, fetchOwnerNames } from "../../../api_calls/campaignRequests";
import { checkUserDetailsFromCookie, checkUserPermissions } from "../../../api_calls/userManagement";
import StoreInfo from "../ModalContent/StoreInfo";
import InterruptedProgress from "../../../components/commonComponents/Progress/InterruptedProgress";
import { fetchStoreNames } from "../../../api_calls/infrastructure";
import { fetchLoopNames, fetchVisualNames, listLoopCampaigns, manageLoopsPaginationCookie, resetLoopsData } from "../../../api_calls/loopCampaign";
import AddLoopCampaign from "../ModalContent/AddLoopCampaign";
import { FileProvider } from "../ModalContent/WizardSteps/FileProvider";
import LoopReview from "../ModalContent/LoopReview";
import { useListingTableController } from "../../../hooks/useListingTableController";
import ListingDataTable from "../../../components/commonComponents/TabularLists/ListingDataTable";
import { setBatchLoadingStatus } from "../../../api_calls/requestConfig";

const LoopsListing = () => {
  const loopsDetails = useSelector((state) => state.userSelections);
  const [showStoresModal, setShowStores] = React.useState(false);
  const [showLoopReview, setShowLoopReview] = React.useState(false);
  const checkUserDetails = checkUserDetailsFromCookie();
  const allowedAccessRights = checkUserPermissions();
  const permissionScope = allowedAccessRights.allowed_access;
  let userDetailObj = {};
  if (checkUserDetails.success === true) {
    userDetailObj = checkUserDetails.user_detail;
  }
  const [userInfo, setUserInfo] = React.useState(userDetailObj);

  let listItems = typeof loopsDetails.loop_campaign_list !== "undefined" ? loopsDetails.loop_campaign_list : [];
  let loopsListitems = listItems.length !== 0 ? listItems : [];

  const [showModal, setShowModal] = React.useState(false);
  const [picInfo, setpicInfo] = React.useState({});
  const [listLoaded, setListLoaded] = React.useState(false);

  const [showCloneConfirmation, setShowCloneConfirmation] = React.useState(false);
  const [cloneLoopInfo, setCloneLoopInfo] = React.useState(null);
  const [cloneModal, setCloneModal] = React.useState(false);

  const initLoopsLookups = React.useCallback(async () => {
    setBatchLoadingStatus(true)
    await Promise.all([
      listLoopCampaigns(),
      // fetchLoopNames(),
      // fetchVisualNames(),
      // fetchStoreNames(),
      // fetchOwnerNames("list-loop-campaigns"),
      fetchIndependentOwnerList(),
    ]).then(() => {
      setBatchLoadingStatus(false);
    });
    // scroll to the last position where user was before refreshing the page
    // scrollTableListings("loops_pagination");
  }, []);

  const { pagination, onPageChange, onPageSizeChange } = useListingTableController({
    paginationReduxKey: "loops_pagination",
    paginationCookieKey: "loops_pagination",
    managePaginationCookie: manageLoopsPaginationCookie,

    // IMPORTANT: pass pagination args through
    loadPage: (pageNumber, pageSize) => listLoopCampaigns(pageNumber, pageSize).then(() => {
      setListLoaded(true);
    }),

    filtersReduxKey: "loop_list_filters",
    filtersCookieKey: "loop_list_filters",
    filterAppliedReduxKey: "loop_list_filter_applied",

    onInit: initLoopsLookups,
    onReset: resetLoopsData,
    deletePaginationScope: "loops_campaign",
    dataLoadedFlag: listLoaded
  });

  const columns = React.useMemo(
    () => [
      {
        id: "name",
        header: "Name",
        cellClassName: "text-wrapper wrapLargeText",
        render: (loop) => <ListingCellLeft>{loop.name}</ListingCellLeft>,
      },
      {
        id: "progress",
        header: "Progress",
        headerAlign: "center",
        align: "center",
        render: (loop) =>
          loop.active === true ? (
            <ProgressBar startDate={loop.start_date} endDate={loop.end_date} />
          ) : (
            <InterruptedProgress startDate={loop.start_date} endDate={loop.end_date} />
          ),
      },
      {
        id: "owner",
        header: "Owner",
        headerAlign: "center",
        align: "center",
        cellClassName: "text-wrapper wrapLargeText",
        render: (loop) => <ListingCellCenter>{loop.loop_company_name}</ListingCellCenter>,
      },
      {
        id: "stores",
        header: "Stores",
        headerAlign: "center",
        align: "center",
        render: (loop) => (
          <ListingCellCenter>
            <Link
              href="#"
              underline="none"
              sx={{ color: "#AF3241" }}
              onClick={(e) => {
                e.preventDefault();
                setpicInfo(loop);
                setShowStores(true);
              }}
            >
              <ListingIconMetric>
                <Store sx={{ color: "#AF3241" }} />
                <ListingMetricValue>
                  <IconText variant="body2">{loop.stores}</IconText>
                </ListingMetricValue>
              </ListingIconMetric>
            </Link>
          </ListingCellCenter>
        ),
      },
      {
        id: "visuals",
        header: "Visuals",
        headerAlign: "center",
        align: "center",
        render: (loop) => (
          <ListingCellCenter>
            <HtmlTooltip title="Active Visuals">
              <ListingIconMetric>
                <PhotoSizeSelectActualOutlined sx={{ color: "#AF3241" }} />
                <ListingMetricValue>
                  <IconText variant="body2">{loop.num_visuals_active}</IconText>
                </ListingMetricValue>
              </ListingIconMetric>
            </HtmlTooltip>
          </ListingCellCenter>
        ),
      },
      // loop_prioritization: disabled for pre_prod deploy — inStore not ready
      {
        id: "campaign_type",
        header: "Type",
        headerAlign: "center",
        align: "center",
        render: (loop) => (
          <ListingCellCenter>
            <HtmlTooltip title={loop.loop_campaign_type_id === "commercial" ? "Commercial" : "Unlimited"}>
              {
                loop.loop_campaign_type_id === "commercial" ? (
                  <Euro sx={{ color: "#AF3241" }} />
                ) : (
                  <AllInclusive sx={{ color: "#AF3241" }} />
                )
              }
            </HtmlTooltip>
          </ListingCellCenter>
        ),
      },
      {
        id: "action",
        header: "Action",
        headerAlign: "center",
        align: "center",
        render: (loop) => {
          const isAvailableToUser =
            (typeof userInfo.current_workspace !== "undefined" &&
              userInfo.current_workspace.id === loop.loop_company_id) ||
            userInfo.user_type === "cyreen" ||
            userInfo.current_workspace.name === loop.retailer_company_name;
          const isEditable = permissionScope.picture_list_can_edit === true && isAvailableToUser;

          return (
            <ListingCellCenter>
              {/* keep icons horizontally spaced */}
              <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
                {/* Edit */}
                {loop.status !== "Completed" ? (
                  permissionScope.picture_list_can_edit === true && loop.active === true ? (
                    isAvailableToUser ? (
                      <HtmlTooltip title="Edit">
                        <a
                          href="#editLoop"
                          aria-label={"edit loop for " + loop.name}
                          onClick={(e) => {
                            e.preventDefault();
                            setShowModal(true);
                            setpicInfo(loop);
                          }}
                        >
                          <Edit sx={{ color: "#AF3241" }} />
                        </a>
                      </HtmlTooltip>
                    ) : (
                      <HtmlTooltipDisabled title="Not Available">
                        <Edit sx={{ color: "#E6E6E6" }} />
                      </HtmlTooltipDisabled>
                    )
                  ) : (
                    <HtmlTooltipDisabled title="No Access">
                      <Edit sx={{ color: "#E6E6E6" }} />
                    </HtmlTooltipDisabled>
                  )
                ) : (
                  <HtmlTooltipDisabled title="Not Available">
                    <Edit sx={{ color: "#E6E6E6" }} />
                  </HtmlTooltipDisabled>
                )}

                {/* Clone */}
                {isEditable ? (
                  <HtmlTooltip title="Clone">
                    <a
                      href="#cloneLoop"
                      aria-label={"clone loop " + loop.name}
                      onClick={(e) => {
                        e.preventDefault();
                        setCloneLoopInfo(loop);
                        setShowCloneConfirmation(true);
                      }}
                    >
                      <ContentCopyTwoTone sx={{ color: "#AF3241" }} />
                    </a>
                  </HtmlTooltip>
                ) : (
                  <HtmlTooltipDisabled title="Not Available">
                    <ContentCopyTwoTone sx={{ color: "#E6E6E6" }} />
                  </HtmlTooltipDisabled>
                )}

                {/* Review */}
                <HtmlTooltip title="Review">
                  <a
                    href="#reviewLoop"
                    aria-label={"review loop for " + loop.name}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowLoopReview(true);
                      setpicInfo(loop);
                    }}
                  >
                    <Visibility sx={{ color: "#AF3241" }} />
                  </a>
                </HtmlTooltip>
              </Box>
            </ListingCellCenter>
          );
        },
      },
    ], []
  );


  return (
    <Box>
      <ListingDataTable
        columns={columns}
        rows={loopsListitems}
        rowKey={(loop, idx) => `${idx}_loop_row`}
        pagination={pagination}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        loading={typeof loopsDetails.loop_campaign_list === "undefined" ? true : loopsDetails?.batchLoading}
      />

      {/* -------- add products modal --------- */}
      {
        showModal === true && (
          <FileProvider>
            <AddLoopCampaign
              open={showModal}
              onClose={() => {
                resetLoopsData();
                setShowModal(false);
              }}
              size={"md"}
              closeModal={() => {
                resetLoopsData();
                setShowModal(false);
              }}
              usedFor={"update"}
              loopinfo={picInfo}
            />
          </FileProvider>
        )
      }

      {/* ------- store names info ------ */}
      {showStoresModal === true && (
        <StoreInfo
          open={showStoresModal}
          onClose={() => {
            setShowStores(false);
          }}
          size={"md"}
          storeInfo={picInfo}
          usedFor={"Campaign"}
          dialogTitle={"Campaign Stores"}
          closeModal={() => {
            setShowStores(false);
          }}
        />
      )}
      {/* ---------- loop review modal --------- */}

      {showLoopReview === true && (
        <FileProvider>
          <LoopReview
            open={showLoopReview}
            onClose={() => {
              resetLoopsData();
              setShowLoopReview(false);
            }}
            size={"md"}
            loopInfo={picInfo}
            closeModal={() => {
              resetLoopsData();
              setShowLoopReview(false);
            }}
          />
        </FileProvider>
      )}

      {/* ------- clone confirmation ------- */}
      {showCloneConfirmation === true && (
        <Confirmation
          showConfirmationPopup={showCloneConfirmation}
          closePopup={() => {
            setShowCloneConfirmation(false);
          }}
          confirmationActionCall={() => {
            resetLoopsData();
            setCloneModal(true);
          }}
          confirmationMessage={
            "You are about to clone an existing loop-based campaign. Please review the copied information carefully, as some details may differ from the original."
          }
          confirmationTitle={"Confirmation"}
          confirmText={"Ok"}
          denyText={"Cancel"}
        />
      )}

      {/* ------- clone loop modal ------- */}
      {cloneModal === true && cloneLoopInfo !== null && (
        <FileProvider>
          <AddLoopCampaign
            open={cloneModal}
            onClose={() => {
              resetLoopsData();
              setCloneModal(false);
              setCloneLoopInfo(null);
            }}
            size={"md"}
            closeModal={() => {
              resetLoopsData();
              setCloneModal(false);
              setCloneLoopInfo(null);
            }}
            usedFor={"add"}
            cloneSource={cloneLoopInfo}
          />
        </FileProvider>
      )}
    </Box>
  );
};

export default LoopsListing;
